import { useEffect } from "react"
//import { GetGenderMode } from "../../../utilities/BL/Zones"


const Thanks = ({ isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")


            // const response = await GetGenderMode()

            // if (response.success) {
            //     setIsActiveWomensMode(response.data.isWomensModeActive)
            // } else {
            //     setIsActiveWomensMode(false)
            // }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Thanks__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Thanks__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='Screen__Thanks__Background__Image' />
                )}
                
                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='Screen__Thanks__Background__Image' /> */}
                {/* <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='Screen__Thanks__Background__Image' /> */}
            </div>

            {/* Contenido */}
            <section className="Screen__Thanks__Container Container-FullHeight">
                <div className="Screen__Thanks__Container__Info">
                    <p className="Welcome__Icon"><i className="bi bi-chat-square-heart"></i></p>
                    <p className="Screen__Thanks__Container__Title">Muchas gracias por participar</p>
                    <p className="Screen__Thanks__Container__Text">Nos vemos en el próximo partido</p>
                </div>
            </section>
            
            {/* Pie de página */}
            <p className='Screen__Thanks__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </p>
        </>
    )
}

export { Thanks };





{/* <section className="Screen__Thanks Container-FullHeight">
    <div className="Screen__Thanks__Lines">
        <div className="Screen__Thanks__Lines__Line Screen__Thanks__Lines__Line--Red"></div>
        <div className="Screen__Thanks__Lines__Line Screen__Thanks__Lines__Line--White"></div>
        <div className="Screen__Thanks__Lines__Line Screen__Thanks__Lines__Line--Red"></div>
        <div className="Screen__Thanks__Lines__Line Screen__Thanks__Lines__Line--White"></div>
    </div>

    <div className="Screen__Thanks__Info">
        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL Screen__Thanks__Logo" alt="Logo" /> /}
        <p className="Welcome__Icon"><i className="bi bi-chat-square-heart"></i></p>
        <p className="Screen__Thanks__Title">Muchas gracias por participar</p>
        <p className="Screen__Thanks__Text">Nos vemos en el próximo partido</p>
        {/* <p className="Screen__Thanks__Text"><img src="/img/page/adsl-leon.png" className="Screen__Thanks__Text__Image" /></p> /}
    </div>
</section>

<p className='Screen__Thanks__Footer'>Hecho con ♥ por Interaktia | 2026</p> */}